<template>
  <popup @codd_close="close">
    <div class="popup-valves" :class="{ mobile: device === 'mobile' }">

      <div class="schematics-wrapper" v-if="!selectedValveId || changingValve">
        <div class="head">
          <h5>{{ $t('powerpack.menu.valvePopup.select') }}</h5>
          <span class="close" @click="close"> &times;</span>
        </div>

        <div class="valve-scheme"
            v-for="valve in availableValves"
            :class="{active: selectedValveId === valve.id}"
            :value="valve.id"
            @click="selectValve(valve.id)"
        >
          <img :src="valve.schematic" alt=""
              v-if="valve.schematic">
          <div class="whitespace" v-else>
          </div>
          <div class="info">
            <span class="name">
              {{ valve.value }}
            </span>
          </div>
        </div>
      </div>

      <div class="schematics-wrapper" v-if="changeAdditionalValveIndex !== null">
        <div class="head">
          <h5>{{ $t('powerpack.menu.valvePopup.selectAdditional') }}</h5>
          <span class="close" @click="close"> &times;</span>
        </div>

        <div class="valve-scheme"
            v-for="valve in availableAdditionalValves"
            :class="{active: changingAdditionalValveId === valve.id}"
            :value="valve.id"
            @click="selectAdditionalValve(valve.id)"
        >
          <img :src="getFromStorage(valve.schematic_image)" alt=""
              v-if="valve.schematic_image">
          <div class="whitespace" v-else>
          </div>
          <div class="info">
            <span class="name">
              {{ translate(valve.name) }}
            </span>
          </div>
        </div>
      </div>

      <div class="second-menu-wrapper" v-if="selectedValve && !changingValve && changeAdditionalValveIndex === null">
        <div class="selection-wrapper">
          <div class="head">
            <h5>{{ $t('powerpack.menu.valvePopup.selected') }}</h5>
          </div>
          <div class="selected-valve">
            <img v-if="selectedValve && selectedValve.schematic"
                :src="selectedValve.schematic" alt="">
            <div class="whitespace" v-else>
            </div>
            <div class="info">
            <span class="name" v-if="selectedValve">
              {{ selectedValve.value }}
            </span>
            </div>
          </div>
          <button class="btn" @click="changingValve = true">{{ $t('powerpack.menu.valvePopup.changeValve') }}</button>
        </div>
        <div class="additional-valves"
            v-if="getMotorOption !== 'open_frame' && (selectedValve && selectedValve.a10 === null || selectedValve && selectedValve.a10 === 0)">
          <div class="head">
            <h5>{{ $t('powerpack.menu.valvePopup.addAdditional') }}:</h5>
          </div>
          <additional-valves
              v-for="(key, i) in this.valve.additionalValves"
              :key="i"
              :additional-valve-id="key"
              :additional-valve-index="i"
              :valve-index="selectedValveIndex"
              @edit="editAdditionalValve"
          />

          <button class="btn" @click="addAdditionalValve" v-if="availableAdditionalValves.length > 0"
              style="padding-right: 30px;">
            {{ $t('powerpack.menu.valvePopup.selectAdditional') }} <span>&#43;</span>
          </button>
        </div>
      </div>

      <div class="footer" v-if="selectedValveId && changeAdditionalValveIndex === null">
        <button class="btn" @click="deleteValve">
          {{ $t('powerpack.menu.valvePopup.remove') }}
        </button>
        <button class="btn" @click="close">
          {{ $t('powerpack.menu.valvePopup.save') }}
        </button>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from "./Popup";
import AdditionalValves from './PopupValveAdditionalValves';
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

import { filter } from 'lodash';
import {getFromStorage} from "@/helpers/backendStorage";

export default {
  name: "PopupValve",

  data() {
    return {
      changingValve: false,
      changeAdditionalValveIndex: null,
    }
  },

  props: {
    selectedValveIndex: {
      type: Number,
      required: true,
    },
  },

  components: {
    Popup,
    AdditionalValves,
  },

  computed: {
    ...mapGetters({
      getMotorOption: 'build/getMotorOption',
      device: 'getDevice',
    }),
    selectedValveId: {
      get() {
        return this.valve.id;
      },
      set(valveId) {
        this.$store.dispatch('build/valves/switchValve', {
          index: this.selectedValveIndex,
          id: valveId,
        });
      }
    },
    selectedValve() {
      return this.availableValves.find((valve) => {
        return valve.id === +this.selectedValveId;
      })
    },
    ...mapState({
      bvalves: state => state.build.valves.all,
      valves: state => state.valves.all,
      allAdditionalValves: state => state.additionalValves.all,
    }),
    valve() {
      return this.bvalves[this.selectedValveIndex];
    },
    availableValves() {
      let valves = [];
      let motorOption = this.getMotorOption;

      for (let key in this.valves) {
        if (this.valves[key][motorOption]) {
            valves.push(this.valves[key]);
        }
      }

      return valves.map(valve => {
        return {
          id: valve.id,
          value: this.translate(valve.name),
          schematic: getFromStorage(valve.schematic_image),
          image: getFromStorage(valve.image),
          a10: valve.a10,
        }
      });
    },
    availableAdditionalValves() {
      let motorOption = this.getMotorOption;
      return filter(this.allAdditionalValves, (additionalValve) => {
        return additionalValve[motorOption];
      });

    },
    changingAdditionalValveId() {
      return this.valve.additionalValves[this.changeAdditionalValveIndex];
    },
    leftOverAdditionalValves() {
      return Object.values(this.allAdditionalValves) // To array
          .filter(valve => {
            return !this.valve.additionalValves.includes(parseInt(valve.id));
          });
    },
  },
  methods: {
    getFromStorage,
    ...mapActions({
      switchValve: 'build/valves/switchValve'
    }),
    selectValve(id) {
      this.selectedValveId = id;
      this.changingValve = false;
    },
    selectAdditionalValve(id) {
      this.$store.commit('build/valves/updateAdditionalValve', {
        valveIndex: this.selectedValveIndex,
        index: this.changeAdditionalValveIndex,
        id
      });
      this.changeAdditionalValveIndex = null;
    },
    deleteValve() {
      this.$store.commit('build/valves/removeValve', this.selectedValveIndex);
      this.$emit('close');
    },
    close() {
      if (this.selectedValveId === null) {
        this.$store.commit('build/valves/removeValve', this.selectedValveIndex);
      }

      this.$emit('close');
    },
    addAdditionalValve() {
      if (this.leftOverAdditionalValves.length < 1) return;

      this.$store.commit('build/valves/addAdditionalValve', {
        valveIndex: this.selectedValveIndex,
        id: this.availableAdditionalValves[0].id,
      })

      this.changeAdditionalValveIndex = this.valve.additionalValves.length - 1;
    },
    editAdditionalValve(index) {
      this.changeAdditionalValveIndex = index;
    },
  }
}
</script>

<style scoped lang="scss">
.popup-valves {
  &.mobile {
    .schematics-wrapper {
      .valve-scheme {
        width: calc(90% - 5px);
      }
    }

    .second-menu-wrapper {
      flex-direction: column;

      .selection-wrapper {
        width: 100%;
      }

      .additional-valves {
        width: 100%;
        align-items: flex-start;
      }
    }

    .footer {
      margin-bottom: 16px;
    }
  }
}

.card-list {
  padding: 0;
}

.head {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 5px 0 0;
  margin-bottom: 10px;

  .close {
    font-size: 40px;
    transition: all ease 0.3s;
    position: absolute;
    top: 16px;
    right: 16px;
    color: #A4AFB7;
    opacity: 1;
    text-shadow: none;
    font-weight: 100;

    &:hover {
      cursor: pointer;
      color: darken(#A4AFB7, 50%);
    }
  }
}

.schematics-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  padding: 20px;
  overflow: auto;
  align-items: flex-start;
  justify-content: flex-start;
  margin: -10px;

  .valve-scheme {
    margin: 10px 10px 20px;
    border-radius: 10px;
    width: calc(33% - 20px);
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    background-color: white;
    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    transition: all ease 0.3s;
    transform: translate3d(0, 0, 0);
    text-rendering: optimizeSpeed;
    padding: 10px;

    &.active {
      border: 2px solid #3DB0C7;
    }

    &:hover {
      box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
      transform: translate3d(0, 0, 0) scale(1.05);
    }

    img {
      max-width: 100%;
      padding: 10px 0;
      height: auto;
    }

    .whitespace {
      background-color: white;
      width: 100%;
      margin: 8px auto;
      height: auto;
      min-height: 163px;
    }

    .info {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-content: center;
      transition: all ease 0.3s;
      font-size: 12px;

      .name {
        transition: all ease 0.5s;
        color: black;
        font-weight: bold;
      }
    }
  }
}


.second-menu-wrapper {
  display: flex;
  flex-direction: row;
  height: auto;
  min-height: 400px;
  padding: 20px;
  overflow: auto;

  .selection-wrapper {
    width: 50%;

    .selected-valve {
      margin-right: auto;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-content: center;
      text-align: center;

      img {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
      }
    }
  }

  .additional-valves {
    //margin: 5px 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

button {
  display: flex;
  justify-content: space-between;
  color: white;
  text-transform: uppercase;
  background-color: #3DB0C7;
  height: 40px;
  align-content: center;
  align-items: center;
  margin-top: 5px;
  border-radius: 50px;
  font-size: 12px;
  letter-spacing: 0.5px;
  max-width: 280px;
  font-weight: 700;
  border: 2px solid #EBEBEB;
  padding: 0 20px;

  &:hover {
    background-color: darken(#3DB0C7, 10%);
    color: white;
  }

  span {
    transform: scale(1.8);
    padding-left: 15px;
    padding-right: 10px;
    margin-right: -15px;
  }
}

.selected-valve {
  max-width: 270px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  background-color: white;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.3);
  padding: 10px;
  margin-bottom: 15px;

  img {
    max-width: 100%;
    padding: 10px 0;
    height: auto;
  }

  .whitespace {
    background-color: white;
    width: 95%;
    margin: 8px auto;
    height: auto;
    min-width: 305px;
    min-height: 163px;
  }

  .info {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-content: center;
    transition: all ease 0.3s;
    font-size: 12px;

    .name {
      transition: all ease 0.5s;
      color: black;
      font-weight: bold;
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-bottom: 15px;

  button {
    color: white;
    text-transform: uppercase;
    background-color: #3DB0C7;
    height: 40px;
    margin-top: 5px;
    border-radius: 50px;
    font-size: 12px;
    letter-spacing: 0.5px;
    min-width: 160px;
    text-align: center;
    display: block;
    padding: 0 30px;
    font-weight: 700;
    border: 2px solid #EBEBEB;
    margin-right: 15px;
    /*box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.16);*/

    &:first-child {
      background-color: unset;
      color: gray;
      padding: 0 25px;

      &:hover {
        background-color: lighten(#aeaeae, 20%);
      }
    }

    &:hover {
      background-color: darken(#3DB0C7, 20%);
    }
  }

  .option {
    white-space: unset;
  }
}
</style>
